import React from 'react'
import {
  PrevMatchupTeamHeadCon,
  PrevMatchupTeamInfo,
  PrevMatchupTeamLogo,
} from './styles'
import { getTeamLogo, getFullTeamName } from '../../../../Utils'

type TeamStatsProps = {
  homeTeamId: string
  awayTeamId: string
}

export const Header: React.FC<React.PropsWithChildren<TeamStatsProps>> = ({
  awayTeamId,
  homeTeamId,
}) => {
  const awayLogo = getTeamLogo(awayTeamId)
  const homeLogo = getTeamLogo(homeTeamId)
  return (
    <>
      <PrevMatchupTeamHeadCon>
        <div className="left">
          <PrevMatchupTeamLogo src={awayLogo} alt="" />
          <PrevMatchupTeamInfo side={'left'}>
            <h2>{getFullTeamName(awayTeamId)}</h2>
          </PrevMatchupTeamInfo>
        </div>
        <div className="right">
          <PrevMatchupTeamInfo side="right">
            <h2>{getFullTeamName(homeTeamId)}</h2>
          </PrevMatchupTeamInfo>
          <PrevMatchupTeamLogo src={homeLogo} alt="" />
        </div>
      </PrevMatchupTeamHeadCon>
    </>
  )
}
